"use strict";
/**
 *
 * Paper
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("../styles");
const styles = styles_1.createStyles((theme) => {
    const elevations = {};
    theme.shadows.forEach((shadow, index) => {
        elevations[`elevation${index}`] = {
            boxShadow: shadow,
        };
    });
    return Object.assign({ 
        /* Styles applied to the root element. */
        root: {
            backgroundColor: theme.palette.surface,
            color: theme.palette.textPrimary,
            transition: theme.transition.create('box-shadow'),
        }, 
        /* Styles applied to the root element if `square={false}`. */
        rounded: {
            borderRadius: theme.shape.borderRadius,
        } }, elevations);
});
const Paper = react_1.default.forwardRef(function Paper(props, ref) {
    const { classes, className: classNameProp, component: Component = 'div', square = false, elevation = 1 } = props, other = __rest(props, ["classes", "className", "component", "square", "elevation"]);
    const className = clsx_1.default(classes.root, classes[`elevation${elevation}`], {
        [classes.rounded]: !square,
    }, classNameProp);
    return react_1.default.createElement(Component, Object.assign({ className: className, ref: ref }, other));
});
if (process.env.NODE_ENV !== 'production') {
    Paper.displayName = 'Paper';
}
const StyledPaper = styles_1.withStyles(styles)(Paper);
exports.Paper = StyledPaper;
